import React from "react"
import { Row, Col } from 'antd';
import './style.scss'
const arrs = [
  // { time: '02:50pm - 03:00pm', con: "Opening Remarks: Yinpeng Dong" },
  { time: '', con: "Session 1" },
  { time: '03:00pm - 03:30pm', con: "Invited Talk #1: Maksym Andriushchenko: “Adversarially robust image attribution against fake images”" },
  { time: '03:30pm - 04:00pm', con: "Invited Talk #2: Florian Tramer" },
  { time: '04:00pm - 04:10pm', con: "Contributed Talk #1: Florian Jaeckle: “Attention for Adversarial Attacks: Learning from your Mistakes”" },
  { time: '04:10pm - 04:20pm', con: "Contributed Talk #2: Zihao Wang: “Goal-Oriented Data-Centric Robust Learning”" },
  { time: '04:20pm – 04:30pm', con: "Contributed Talk #3: Wenkai Zheng: “Data Enhancement with Multiple Adversarial Perturbation Constraints”" },
  { time: '', con: "Session 2" },
  { time: '04:30pm - 05:00pm', con: "Invited Talk #3: Alex Lamb" },
  { time: '05:00pm - 05:30pm', con: "Invited Talk #4: Hadi Salman" },
  { time: '05:30pm - 05:40pm', con: "ARES-Bench Release: Xiaofeng Mao" },
  { time: '05:40pm - 05:50pm', con: "Contributed Talk #4: Jayaram Raghuram:“Revisiting Adversarial Robustness of Classifiers With a Reject Option”" },
  { time: '05:50pm - 06:00pm', con: "Contributed Talk #5: Yiqi Zhong: “Exploiting the Potential of Datasets: A Data-Centric Approach for Model Robustness”" },
  { time: '06:00pm – 07:00pm', con: "Poster Session & Dinner" },
]
const arrs1 = [
  { time: '', con: 'Session 3' },
  { time: '07:00pm - 07:30pm', con: 'Invited Talk #5: Jingfeng Zhang: “Adversarial Robustness: From Basic Science to Some Applications”' },
  { time: '07:30pm – 08:00pm', con: 'Invited Talk #6: Chaowei Xiao' },
  { time: '08:00pm – 08:30pm', con: 'Invited Talk #7: Xiaofeng Mao' },
  { time: '08:30pm – 08:40pm', con: 'Contributed Talk #6: Chawin Sitawarin:“Demystifying the Adversarial Robustness of Random Transformation Defenses”' },
  { time: '08:40pm – 08:50pm', con: 'Contributed Talk #7: Qiwei Tian: “Improving Adversarial Robustness with Data-Centric Learning”' },
  { time: '08:50pm – 09:00pm', con: 'Contributed Talk #8: Jian Zhao: “Mix Saturation Attack Data like Cocktail for Robust Learning”' },
]
export default function Schedule() {
  return <div className="page-schedule">
    <div className="schedule-title">Schedule <span className="sub-title">The time is in Pacific Time (PT).</span></div>
    <Row className="list-ul">
      <Col span={24} className="time-header">
        <span className="time">02:50pm - 03:00pm</span>
        <span className="event">Opening Remarks: Yinpeng Dong</span>
      </Col>
      <Col span={24} className="list-li">
        {arrs.map((item, index) => {
          if (item.time) {
            return <div className="list-two" key={index}>
              <span>{item.time}</span>
              <div className="item-con">{item.con}</div>
            </div>
          } else {
            return <div className="list-one" key={index}>
              <span></span>
              <div>{item.con}</div>
            </div>
          }
        })}
      </Col>
      <Col span={24} className="list-li">
        {arrs1.map((item, index) => {
          if (item.time) {
            return <div className="list-two" key={index}>
              <span>{item.time}</span>
              <div className="item-con">{item.con}</div>
            </div>
          } else {
            return <div className="list-one" key={index}>
              <span></span>
              <div>{item.con}</div>
            </div>
          }
        })}
      </Col>
    </Row>
  </div>
}
